import { useState } from "react";

import {
  MentorProfileStatus,
  usePauseMentorProfileAsAdmin,
  type MentorProfile,
} from "@/entities/mentors-profile";
import { Button } from "@/shared/ui/button";
import { DropdownMenuItem } from "@/shared/ui/dropdown-menu";
import { Modal } from "@/shared/ui/Modal";
import { Skeleton } from "@/shared/ui/skeleton";

export const MentorProfilePreviewModal = ({
  mentorProfile,
}: {
  mentorProfile: MentorProfile;
}) => {
  const toggleProfile = usePauseMentorProfileAsAdmin();
  const isPaused = mentorProfile.status !== MentorProfileStatus.ACTIVE;

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <Modal>
      <Modal.Trigger asChild>
        <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
          Посмотреть анкету
        </DropdownMenuItem>
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Наставник #{mentorProfile.mentorUsername}</Modal.Title>
        {!isImageLoaded && <Skeleton className="h-56 w-full rounded-md" />}
        <img
          src={mentorProfile.imageUrl}
          className="rounded-md"
          onLoad={() => setIsImageLoaded(true)}
          onError={() => setIsImageLoaded(true)}
        />
        <p className="text-textColor">{mentorProfile.description}</p>

        <Button onClick={() => toggleProfile(mentorProfile)}>
          {isPaused
            ? "Возобновить анкету в выдаче"
            : "Поставить анкету на паузу"}
        </Button>
        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
